import { hGet } from '@mcfe/tools';

// 生鲜招投标和PB招投标用的一套接口，本次用新接口都加Source
export const API_URL_LIST = {
    QUERY_LIST: '/api/vss/second/shepherd/tender/pageQuerySource', // 招投标列表查询
    CANCEL_BIDDING: '/api/vss/shepherd/tender/cancelBiddingSource', // 取消招投标
    SUBMIT_SKILL_BIDDING: '/api/vss/shepherd/tender/submitSkillBiddingSource', // 技术标(非价格标)提交
    SUBMIT_FILE_MODIFY: '/api/vss/second/shepherd/tender/submitFile', // 技术标(非价格标)-证明材料提交
    // 价格标详情
    SKU_PRICE_RESULT: '/api/vss/second/shepherd/tender/skuPriceResultListSource',
    SUBMIT_PRICE_BIDDING: '/api/vss/shepherd/tender/submitPriceBiddingSource', // 价格标提交
    SECOND_SUBMIT_PRICE_BIDDING: '/api/vss/shepherd/tender/submit/price/second', // PB-二次报价-价格标提交
    DETAIL: '/api/vss/second/shepherd/tender/detailSource', // 详情
    SUPPLIER_SKILL_DETAIL: '/api/vss/second/shepherd/tender/supplierSkillDetailSource', // 技术标(非价格标)详情
};

export const getSkuPriceResultListApi = async (params, config) => hGet(API_URL_LIST.SKU_PRICE_RESULT, params, config);
